<form>
  <input id="forceSync"
         type="checkbox"
         [formControl]="forceSyncForm" />
</form>